import * as React from "react";
import { useCallback } from "react";
import { TableCell } from "@mzc-pdc/ui";
import { Grid } from "@mui/material";
import Skeleton from "@components_v2/skeleton/skeleton";

export const SkeletonAssetsTable = ({ columns, hideCheckbox = false }) => {
    const getSkeletonByColumn = useCallback(
        (column) => {
            const { id: columnId, style } = column;
            if (!columnId) return;
            if (columnId === "desiredStatus")
                return <Skeleton variant="rounded" animation={"wave"} width={32} height={18} />;
            if (columnId === "name")
                return (
                    <Grid
                        container
                        direction={`row`}
                        justifyContent={`flex-start`}
                        alignItems={`center`}
                        flexWrap={"nowrap"}
                        width={`calc(100% - 32px)`}
                    >
                        <Grid item>
                            <Skeleton variant="rounded" animation={"wave"} width={52} height={52} sx={{ mr: 1.5 }} />
                        </Grid>
                        <Grid item flex={1}>
                            <Skeleton variant="rounded" animation={"wave"} width={"100%"} height={21} />
                        </Grid>
                    </Grid>
                );
            if (columnId === "mediaType")
                return <Skeleton variant="rounded" animation={"wave"} width={170} height={18} />;
            if (columnId === "size")
                return (
                    <Grid container direction={`column`} justifyContent={`flex-start`} alignItems={`center`}>
                        <Grid item>
                            <Skeleton variant="rounded" animation={"wave"} width={76} height={18} />
                        </Grid>
                    </Grid>
                );
            if (columnId === "extensions")
                return <Skeleton variant="rounded" animation={"wave"} width={170} height={18} />;
            if (columnId === "duration")
                return <Skeleton variant="rounded" animation={"wave"} width={100} height={18} />;
            if (columnId === "type") return <Skeleton variant="rounded" animation={"wave"} width={76} height={18} />;
            return <Skeleton variant="rounded" animation={"wave"} width={style?.custom?.width ?? 100} height={18} />;
        },
        [columns],
    );

    return (
        <>
            {!hideCheckbox && (
                <TableCell sx={{ width: "42px" }} padding="checkbox">
                    <Skeleton variant="rounded" animation={"wave"} width={18} height={18} />
                </TableCell>
            )}
            {columns &&
                columns.map((column) => (
                    <TableCell
                        key={column.id}
                        mt={1}
                        mb={1}
                        sx={{
                            ...{ width: column?.style?.custom?.width ?? undefined },
                        }}
                    >
                        {getSkeletonByColumn(column)}
                    </TableCell>
                ))}
        </>
    );
};

export default SkeletonAssetsTable;
